module.exports = __webpack_public_path__ + "img/discount_flag.9dbe2a6a.png";